import React from 'react'
//import { FormattedHTMLMessage } from 'react-intl'

export const Video = () => (
    <div className='Container'>
        <div className='video-container' >
	    <iframe title="youtube_frame" src="https://www.youtube.com/embed/Smt6OnugqnI" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; 
picture-in-picture" allowfullscreen></iframe>
        </div>
    </div>
)

export default Video;



// WEBPACK FOOTER //
// ./src/containers/Video.jsx